var _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Menu",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 24,
    height: 2,
    rx: 1,
    fill: "#1e1e1e"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 24,
    height: 2,
    rx: 1,
    transform: "translate(0 6)",
    fill: "#1e1e1e"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 24,
    height: 2,
    rx: 1,
    transform: "translate(0 12)",
    fill: "#1e1e1e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon_menu.fb295e7733592e0ad2c6dba6f2b5af94.svg";
export { ForwardRef as ReactComponent };